import { NgModule } from '@angular/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { NgSelectModule } from '@ng-select/ng-select';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';

@NgModule({
    imports: [
        NgSelectModule,
        ScrollingModule,
        DragDropModule,
        MatMenuModule,
        MatButtonModule,
        OverlayModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatTableModule,
        NgSelectModule,
        MatSnackBarModule,
        MatDialogModule,
    ],
    declarations: [
    ],
    exports: [
        MatProgressBarModule,
        NgSelectModule,
        ScrollingModule,
        DragDropModule,
        MatMenuModule,
        MatButtonModule,
        MatTooltipModule,
        MatTableModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSnackBarModule,
        MatDialogModule,
        OverlayModule
    ],
    providers: []
})
export class MaterialModule { }
